<div class="card-container" [class]="{
  'large-card': size() === CardSize.large,
  'medium-card': size() === CardSize.medium,
  'small-card': size() === CardSize.small,
  }">
  <div class="card-header-frame">
    <div class="card-header">
      <lib-loading-shimmer [showLoading]="titleLoading()" width="25%"><span class="card-title">{{ titleText() }}</span></lib-loading-shimmer>
    </div>
    @if (infoLabel()) {
      <div class="card-info-label font-secondary font-label-large font-medium">
        <mat-icon class="d-flex card-info-icon" svgIcon="info"></mat-icon>
        {{ infoLabel() }}
      </div>
    }
  </div>
  <ng-content></ng-content>
</div>
